import {
    Cpu,
    Gauge,
    Layers,
    Rocket,
    ShieldCheck,
    Sparkles,
    Users,
} from "lucide-react";

const whyChooseTechnologies = [
    {
        id: 1,
        title: "Right Tool For The Right Job",
        description:
            "We don't shoehorn every project into the same stack. Our engineers pick technologies based on your goals — performance, scalability, budget, and long-term maintainability.",
        icon: <Layers />,
    },
    {
        id: 2,
        title: "Modern, Future-Proof Stack",
        description:
            "From React 18 and TypeScript to LLM-powered backends, we build on stacks that keep your product competitive for years, not months.",
        icon: <Sparkles />,
    },
    {
        id: 3,
        title: "Performance By Default",
        description:
            "Every technology in our toolkit is battle-tested for speed. Sub-second loads, optimized queries, and lean bundles — performance is a first-class citizen.",
        icon: <Gauge />,
    },
    {
        id: 4,
        title: "Enterprise-Grade Security",
        description:
            "OWASP-compliant patterns, encrypted data at rest and in transit, role-based access control, and continuous vulnerability scanning across our entire stack.",
        icon: <ShieldCheck />,
    },
    {
        id: 5,
        title: "Cross-Platform Experts",
        description:
            "One team for web, mobile, cloud, and AI. No handoffs, no silos — a unified team that ships cohesive products across every surface.",
        icon: <Users />,
    },
    {
        id: 6,
        title: "AI-Native Engineering",
        description:
            "We embed LLMs, RAG pipelines, and autonomous agents directly into the products we ship — turning static software into intelligent systems.",
        icon: <Cpu />,
    },
    {
        id: 7,
        title: "Ship Fast, Iterate Faster",
        description:
            "Battle-tested CI/CD pipelines, containerized deployments, and observability baked in — so your team ships confidently, every single day.",
        icon: <Rocket />,
    },
];

export default whyChooseTechnologies;
